import { Component, Inject, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/sharedService';
import { InformationDialogComponent } from '../information-dialog/information-dialog.component';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';
import { MapService } from '../../map/map.service';

interface DynamicModalData {
  component: Type<any>;
  data?: any;
  listeners?: any
}

@Component({
  selector: 'app-blank-dialog',
  templateUrl: './blank-dialog.component.html',
  styleUrls: ['./blank-dialog.component.css']
})
export class BlankDialogComponent implements OnInit {
  actionButtons: []
  text: string;
  extraData: any;


  obj: any;
  action: any;

  error = false;

  constructor(
    public dialogRef: MatDialogRef<BlankDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DynamicModalData, public sharedService: SharedService, private mapService: MapService, public dialog: MatDialog, private propertyTaxService: PropertyTaxService) {
    this.actionButtons = data['actionButtons']
    // this.extraData = data['data']
    // this.text = data['text'];
    // this.obj = data['obj']
    // this.action = data['action']
    // this.error = data['error']
  }
  @ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;


  ngOnInit(): void {
    this.container.clear();
    const componentRef = this.container.createComponent(this.data.component);

    if (this.data.data && componentRef.instance) {
      Object.assign(componentRef.instance, this.data.data);
      if (this.data.listeners) {
        this.data.listeners.forEach(listener => {
          componentRef.instance[listener].subscribe(data => {
            if (listener === 'onActionStateChange') {
              this.updateActionButtons(data);
            } else {
              this.dialogRef.close(data);
            }
          });
        });
      }
    }
  }

  updateActionButtons(state) {
    if (!state || !this.actionButtons) {
      return;
    }
  
    this.actionButtons.forEach((button: any) => {
      if (button.action === 'SAVE') {
        button.disabled = !state.canSave;
      }
  
      if (button.action === 'DECLARE') {
        button.disabled = !state.canDeclare;
        button.taxPayer = state.taxPayer;
      }
  
      if (button.action === 'DELETE') {
        button.disabled = !state.id;
        button.id = state.id;
        button.lotId = state.lotId || button.lotId;
      }
    });
  }
  async deleteButton(id, lotId = null) {
    try {
      if (lotId) this.mapService.deleteFeatureAttributes$(lotId).toPromise();
      this.propertyTaxService.deletePropertyTaxLot(id).toPromise()
      this.sharedService.closePropertyTaxForm();

      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: "DIALOG.PROP_TAX_DELETED" }
      });

      this.dialogRef.close(true);

    } catch (err) {
      console.error("Delete failed:", err);

      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: "DIALOG.PROP_TAX_DELETE_ERROR" }
      });
    }
  }


  buttonAction(action,button) {
    switch (action) {
      case 'SAVE':
        this.sharedService.saveForm();
        //this.dialogRef.close(true);
        break;
        case 'DECLARE': {
          const dialogData: any = this.data?.data;
                
          this.sharedService.addPropertyTax(dialogData?.type, 0, {
            taxPayer: button?.taxPayer,
            declare: true
          });
        
          break;
        }
      case 'DELETE':
        if(button.id){
          this.deleteButton(button.id, button.lotId);
        }
        break;
      case 'CANCEL':
        this.dialogRef.close(false)
        break;
      default:
        break;
    }
  }

}
